import { ConfigState, SetConfigAction, SET_CONFIG } from "./types";

export function setConfig(payload: Partial<ConfigState>): SetConfigAction {
  return {
    type: SET_CONFIG,
    payload,
  };
}
